<template>
	<div v-if="cmsCareerClusters.length" class="card-page">
		<ja-header
			:title="$t('gamePlayMetaTitles.clusters')"
			subtitle="JA Finance Park"
		>
			<template v-slot:icon>
				<svgicon name="headerIcons/clusters"></svgicon>
			</template>
		</ja-header>
		<content>
			<div class="building-wrapper">
				<ja-building-header
					:asset="'page-headers/career-building'"
					:billboard-asset="localSponsor"
					billboard-position="right"
					type="page-header"
				></ja-building-header>
			</div>
			<h1 class="heading">{{ $t('careerClustersTitle') }}</h1>
			<h2 class="sub-heading body-text-1">
				{{ $t('careerClustersTitleInfo') }}
			</h2>
			<ja-carousel
				:items="cmsCareerClusters"
				:selected-cluster="selectedCluster"
				@selectCluster="selectCluster"
			></ja-carousel>
		</content>
	</div>
</template>
<script>
import gql from 'graphql-tag';
import '@/components/icons/headerIcons/clusters';
import Header from '@/components/ui/headers/Header';
import CareerCarousel from '@/components/CareerCarousel/CareerCarousel';
import BuildingHeader from '@/components/ui/headers/BuildingHeader';
import LocalSponsorService from '@/services/LocalSponsorService';
import UserData from '../mixins/UserData';

export default {
	components: {
		jaHeader: Header,
		jaCarousel: CareerCarousel,
		jaBuildingHeader: BuildingHeader
	},
	mixins: [UserData],
	props: {
		selectedCluster: {
			type: String,
			default: null
		}
	},
	data() {
		return {
			cmsCareerClusters: [],
			localSponsor: null,
			skipQuery: true
		};
	},
	computed: {
		constants() {
			return this.$store.getters.constants;
		}
	},
	watch: {
		constants() {
			this.skipQuery = false;
		}
	},
	mounted() {
		if (this.constants) {
			this.skipQuery = false;
		}
		this.$store.commit('setLoading', true);
		LocalSponsorService.getLogo(
			'Careers',
			this.userData.studentFacilityId
		).then(logo => (this.localSponsor = logo));
	},
	created() {
		if (this.userData) {
			this.$store.dispatch('getPauseState');
		}
	},
	methods: {
		selectCluster(cluster) {
			this.$store.commit('setLoading', true);
			sessionStorage.setItem('careerCluster', JSON.stringify(cluster));
			this.$router.push({ name: 'careers' });
		}
	},
	apollo: {
		cmsCareerClusters: {
			query: gql`
				query clusters($jtWhere: String!) {
					cmsCareerClusters(
						where: "CmsCareers.Count(it.isActive=\\"true\\")>0"
					) {
						name
						careerCluster_ID
						imageBase64
						cmsCareers(
							where: "isActive=\\"true\\" && CmsCareerJobtitles.Count(it.isActive=\\"true\\")==4"
						) {
							career_ID
							name
							description
							education
							interests
							describeSkills
							skills
							expectedDuties
							outlook
							jobSatisfaction
							cmsCareerJobTitles(
								where: $jtWhere
								order: "CmsLifeStage.DisplayOrder"
							) {
								cmsLifeStage {
									displayOrder
								}
								jobTitle
								salary
								careerJobTitle_ID
							}
							cmsEducation {
								education_ID
							}
						}
					}
				}
			`,
			variables() {
				return {
					jtWhere: `isActive="true" && lifeStage_ID != "${this.constants.teenagerAdultLifeStageGuid}"`
				};
			},
			update(data) {
				this.$store.commit('setLoading', false);
				return data.cmsCareerClusters;
			},
			skip() {
				return this.skipQuery;
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.card-page {
	overflow-x: hidden;

	.building-wrapper {
		width: 768px;
		margin: auto;
	}
}

.clusters-description {
	text-align: center;
	width: 66%;
}
</style>
